import styled from 'astroturf'
import React from 'react';

const Container = /*#__PURE__*/styled('header', null, {
  displayName: "Container",
  styles: require("./index-Container.module.css"),
  attrs: null,
  vars: []
});

const HeroBackground = /*#__PURE__*/styled('div', null, {
  displayName: "HeroBackground",
  styles: require("./index-HeroBackground.module.css"),
  attrs: null,
  vars: []
});

const HeroOverlay = /*#__PURE__*/styled("div", null, {
  displayName: "HeroOverlay",
  styles: require("./index-HeroOverlay.module.css"),
  attrs: null,
  vars: []
});

const styles = require('./index-styles.module.css');

interface Props {
  children?: React.ReactNode;
  className?: string;
  short?: boolean;
  bright?: boolean;
  renderBackground?(props: { className: string }): React.ReactNode;
}

export default function Hero({ children, className, short, bright, renderBackground }: Props) {
  const background = renderBackground?.({ className: styles.bg });
  return (
    <Container long={!short} className={className}>
      <HeroBackground bright={bright}>
        {background}
      </HeroBackground>
      <HeroOverlay>{children}</HeroOverlay>
    </Container>
  );
}
